import React, { useEffect, useRef, useState } from 'react'
import { get_check_mobile_register, otp_request, otp_verify, save_map_customer_line_account } from '../../page_action/authen_otp';
import { ToastWarning } from '../../app_services/ToastService';
import { get_main_user_data } from '../../page_action/app_main';
import { AlertWarning } from '../../app_services/AlertService';

export default function OTPVerifyForm({ lineData, setUserData }) {
    const [step, setStep] = useState('phone');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '']);
    const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef()];
    const [refCode, setRefCode] = useState('');
    const [token, setToken] = useState('');

    // ฟังก์ชันสำหรับแยก OTP จากข้อความ SMS
    const extractOTPFromMessage = (text) => {
        // ลองหาตัวเลข 5 หลักที่อยู่ติดกัน
        const matches = text.match(/\d{5}/g);
        if (matches && matches.length > 0) {
            return matches[0]; // เอาชุดแรกที่เจอ
        }
        // ถ้าไม่เจอ ให้เอาเฉพาะตัวเลขทั้งหมด
        return text.replace(/\D/g, '').slice(0, 5);
    };

    // ปรับปรุงฟังก์ชัน fillOTP
    const fillOTP = (otpText) => {
        const extractedOTP = extractOTPFromMessage(otpText);
        const digits = extractedOTP.split('');
        const newOtp = [...otp];
        digits.forEach((digit, index) => {
            if (index < 5) {
                newOtp[index] = digit;
            }
        });
        setOtp(newOtp);
    };

    // SMS Listener
    useEffect(() => {
        if (step === 'otp') {
            if ('OTPCredential' in window) {
                const ac = new AbortController();
                navigator.credentials.get({
                    otp: { transport: ['sms'] },
                    signal: ac.signal
                }).then(otp => {
                    if (otp && otp.code) {
                        fillOTP(otp.code);
                    }
                }).catch(err => {
                    console.log(err);
                });

                return () => {
                    ac.abort();
                };
            }
        }
    }, [step]);

    // Phone number handlers
    const handlePhoneSubmit = async (e) => {
        // e.preventDefault();

        let data_check = await get_check_mobile_register({ MOBILE: phoneNumber })
        if (data_check) {
            let data_otp = await otp_request({ "phone_number": phoneNumber, "purpose": "REWARD", LINE_TOKEN: lineData.userId, LINE_NAME: lineData.displayName, LINE_IMG: lineData.pictureUrl });
            if (!data_otp) {
                return;
            }
            setRefCode(data_otp.ref_code);
            setToken(data_otp.token);
            if (phoneNumber.length >= 10) {
                setStep('otp');
            }
        }

    };

    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        if (value.length <= 10) {
            setPhoneNumber(value);
        }
    };

    // OTP handlers
    const handleKeyDown = (e, index) => {
        if (
            !/^[0-9]{1}$/.test(e.key) &&
            e.key !== 'Backspace' &&
            e.key !== 'Delete' &&
            e.key !== 'Tab' &&
            !e.metaKey
        ) {
            // e.preventDefault();
        }

        if ((e.key === 'Delete' || e.key === 'Backspace') && !otp[index]) {
            if (index > 0) {
                const newOtp = [...otp];
                newOtp[index - 1] = '';
                setOtp(newOtp);
                inputRefs[index - 1].current.focus();
            }
        }
    };

    const handleChange = (e, index) => {
        const value = e.target.value;

        // ตรวจสอบว่าเป็นการวางข้อความหรือไม่
        if (value.length > 1) {
            fillOTP(value);
            return;
        }

        // การกรอกปกติทีละตัว
        if (value && !/^\d+$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value.slice(-1);
        setOtp(newOtp);

        if (value && index < 4) {
            inputRefs[index + 1].current.focus();
        }
    };


    const handleFocus = (e) => {
        e.target.select();
    };

    const handlePaste = (e) => {
        // e.preventDefault();
        const pastedText = e.clipboardData.getData('text');
        fillOTP(pastedText);
        // โฟกัสช่องสุดท้ายหลังวาง
        inputRefs[4].current.focus();
    };

    const handleInput = (e, index) => {
        const value = e.target.value;
        if (value.length > 1) {
            fillOTP(value);
        }
    };


    const handleOtpSubmit = async (e) => {
        try {
            let otp_code = otp.join('');
            if (otp_code.length < 5) {
                ToastWarning('กรุณากรอก รหัสยืนยัน OTP ให้ครบ');
                return;
            }
            let form = {
                phone_number: phoneNumber,
                otp_code: otp_code,
                token: token,
                MOBILE: phoneNumber,
                LINE_TOKEN: lineData.userId,
                LINE_NAME: lineData.displayName,
                LINE_IMG: lineData.pictureUrl
            };
            let res_api_verify = await otp_verify(form, get_main_user_data, setUserData);

            // // ยืนยัน OTP สำเร็จส่งข้อมูลไปบันทึก
            // if (res_api_verify) {
            //     let form_regis = {
            //         MOBILE: phoneNumber,
            //         LINE_TOKEN: lineData.userId,
            //         LINE_NAME: lineData.displayName,
            //         LINE_IMG: lineData.pictureUrl
            //     };
            //     let res_regis = await save_map_customer_line_account(form_regis)

            //     // บันทึกข้อมูลสำเร็จ เรียกข้อมูล authen
            //     if (res_regis) {
            //         await get_main_user_data({ line_userid: lineData.userId }, null, setUserData)
            //     }
            // }
        } catch (error) {
            AlertWarning('เกิดข้อผิดพลาด', JSON.stringify(error))
        }
    };

    const handleResend = async (e) => {
        // e.preventDefault();
        let data_otp = await otp_request({ "phone_number": phoneNumber, "purpose": "REWARD", LINE_TOKEN: lineData.userId, LINE_NAME: lineData.displayName, LINE_IMG: lineData.pictureUrl });
        if (!data_otp) {
            return;
        }
        setRefCode(data_otp.ref_code);
        setToken(data_otp.token);
    };

    const handleBack = () => {
        setStep('phone');
        setOtp(['', '', '', '', '']);
    };

    // Phone input screen
    if (step === 'phone') {
        return (
            <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 bg-fixed"
                style={{
                    backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png?123")',
                    //  backgroundSize: ' 100%'
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                }}>
                <div className="w-full max-w-md mx-auto text-center bg-white px-4 sm:px-8 py-10 rounded-xl shadow ml-3 mr-3 sm:ml-0 sm:mr-0 bg-opacity-90">
                    <header className="mb-4">
                        <div className='flex justify-center'>
                            <img
                                src="https://www.mkmedical.online:444/assets/images/logo-border-white-p.png"
                                className="w-32 sm:w-40 md:w-48"
                                alt="Company Logo"
                            />
                        </div>
                        <h1 className="text-2xl font-bold mb-1 mt-1">ยืนยันหมายเลขโทรศัพท์</h1>
                        <p className="text-sm text-slate-500">
                            ป้อนหมายเลขโทรศัพท์ของคุณ
                        </p>
                        <p className="text-sm text-slate-500">
                            เราจะส่งรหัสยืนยันเพื่อยืนยันหมายเลขโทรศัพท์ของคุณ
                        </p>
                    </header>
                    {/* {JSON.stringify(lineData ? lineData.userId : '')} */}

                    <div>
                        <div className="mb-4">
                            <input
                                type="tel"
                                value={phoneNumber}
                                onChange={handlePhoneChange}
                                placeholder="หมายเลขโทรศัพท์ 10 หลัก"
                                className="w-full text-center text-lg font-medium text-white-900 bg-white-100 
                                border-orange-200
                                border border-transparent hover:border-white-200 rounded p-3 outline-none 
                                focus:bg-white focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
                                maxLength={10}
                            />
                        </div>

                        <div className="max-w-xs mx-auto mb-5">
                            <button
                                onClick={handlePhoneSubmit}
                                type="button"
                                disabled={phoneNumber.length < 10}
                                className="w-full inline-flex justify-center whitespace-nowrap rounded-lg bg-orange-500 px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-orange-950/10 hover:bg-orange-600 focus:outline-none focus:ring focus:ring-orange-300 focus-visible:outline-none focus-visible:ring focus-visible:ring-orange-300 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                ส่งรหัสยืนยัน OTP
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // OTP verification screen
    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-gray-50"
            style={{
                backgroundImage: 'url("https://www.mkmedical.online:444/image_wheel_game/chinese-newyear.png")',
                //  backgroundSize: ' 100%'
                backgroundPosition: 'center',
                backgroundSize: 'cover',

            }}>
            <div className="w-full max-w-md mx-auto text-center bg-white px-4 sm:px-8 py-10 rounded-xl shadow ml-3 mr-3 sm:ml-0 sm:mr-0 bg-opacity-95">
                <header className="mb-8 relative">
                    <div className='flex justify-center'>
                        <img
                            src="https://www.mkmedical.online:444/assets/images/logo-border-white-p.png"
                            className="w-32 sm:w-32 md:w-32"
                            alt="Company Logo"
                        />
                    </div>
                    <button
                        onClick={handleBack}
                        className="absolute left-0 top-0 text-slate-500 hover:text-slate-700"
                    >
                        ← ย้อนกลับ
                    </button>
                    <h1 className="text-2xl font-bold mb-1 mt-1">ยืนยันหมายเลขโทรศัพท์</h1>
                    <p className="text-sm text-slate-500">
                        กรอกรหัสยืนยัน 5 หลักที่ส่งไปยัง {phoneNumber} (Ref: {refCode})
                    </p>
                </header>

                <div>
                    <div className="flex items-center justify-center gap-3">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                ref={inputRefs[index]}
                                type="number"
                                value={digit}
                                onChange={(e) => handleChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                onInput={(e) => handleInput(e, index)}
                                onFocus={handleFocus}
                                onPaste={handlePaste}
                                className="w-14 h-14 text-center text-2xl font-extrabold 
                                text-slate-900 bg-slate-100 border border-transparent 
                                hover:border-slate-200 appearance-none 
                                rounded p-4 outline-none focus:bg-white 
                                focus:border-orange-400 focus:ring-2 
                                focus:ring-orange-100
                                border-orange-200
                                [&::-webkit-inner-spin-button]:appearance-none
                                [&::-webkit-outer-spin-button]:appearance-none"
                                maxLength={1}
                            />
                        ))}
                    </div>

                    <div className="max-w-xs mx-auto mt-4">
                        <button
                            onClick={handleOtpSubmit}
                            type="button"
                            className="w-full inline-flex justify-center whitespace-nowrap rounded-lg bg-orange-500 px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-orange-950/10 hover:bg-orange-600 focus:outline-none focus:ring focus:ring-orange-300 focus-visible:outline-none focus-visible:ring focus-visible:ring-orange-300 transition-colors duration-150"
                        >
                            ยืนยันรหัส OTP
                        </button>
                    </div>
                </div>

                <div className="text-sm text-slate-500 mt-4">
                    ไม่ได้รับรหัส ?{' '}
                    <button
                        onClick={handleResend}
                        className="font-medium text-orange-500 hover:text-orange-600"
                    >
                        ส่งอีกครั้ง
                    </button>
                </div>
            </div>
        </div>
    );
}